<template>
  <main>
    <div class="form">
      <Form :class="'form_step'+step"
            id="form"
            :form_id="form_id"
            :server="server"
            v-on:results="getResult"
            v-on:step-up="checkStep"
            v-on:step-down="checkStep"
            :relay="codes"
          />
    </div>
    <div v-if="step ==1" class="infosups" >En cliquant sur «je joue», j’accepte le <a style="color:red" href="/reglement.pdf" target="_blank">règlement</a>.</div>
  </main>
</template>
<script>
var consts = require('../config');
import axios from "axios";

export default {
  name: "Jouez",
  data: function() {
    return {
      step: 0,
      codes :  { codes : [window.code]},
      form_id: consts.FORM_ID,
      server : consts.SERVER_URL,
    };
  },
  mounted() {
    if(!window.code) {
      this.$router.push("/");
    }
    console.log(this.codes)
  },
  methods: {
    getResult(result) {
      if(result._id) {
        if(result.status =='PERD' || result.status =='DEJA') {
            window.lot = 'lot6' 
        } else {
            if(result.lot == 'courses') {
              window.lot = 'lot1' 
            } else if(result.lot == 'enceinte') {
              window.lot = 'lot2' 
            }  else if(result.lot == 'robot') {
              window.lot = 'lot3'  
            }  else if(result.lot == 'trottinette') {
              window.lot = 'lot4' 
            } else if(result.lot == 'bonsreduc')  {
              window.lot = 'lot5' // bon de reductions
            }
        }
        this.$router.push("/play");
      } else {

         this.$swal({
            confirmButtonColor: '#BD1218',
            title: 'Oups !',
            html: "Erreur de validation"
          });
          return false;
      }
       
    },
    checkStep (step) {
      this.step = step
    }
  }
}
</script>